<i18n>
{
  "pe": {
    "must-type-comment": "Debes ingresar un comentario",
    "title-register-interaction": "Registrar interacción",
    "label-comment": "Comentario"
  },
  "cl": {
    "must-type-comment": "Debes ingresar un comentario",
    "title-register-interaction": "Registrar interacción",
    "label-comment": "Comentario"
  },
  "br": {
    "must-type-comment": "Você deve inserir um comentário",
    "title-register-interaction": "Registrar interação",
    "label-comment": "Comentario"
  }
}
</i18n>
<template>
  <div class="interactions-creator card-item shadowless med-size-text">
    <h4>{{ $t('title-register-interaction') }}</h4>
    <div class="field">
      <label class="is-small">{{ $t('label-comment') }}</label>
      <textarea
        id="comment"
        v-model="interactionToCreate.comment"
        class="textarea"
        rows="2" />
    </div>
    <div>
      <div class="metadata">
        <template v-for="field in fields">
          <div v-if="field.type === 'select'" :key="field.name" class="metadata-entry">
            <b-field :label="field.title" custom-class="has-text-weight-normal">
              <b-select
                :id="field.name"
                v-model="interactionToCreate[field.name]"
                size="is-small"
                rounded
                @input="field.onChange ? field.onChange($event) : {}">
                <option v-for="option in field.possibleOptions" :key="option.slug" :value="option.slug">
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div v-if="field.type === 'datepicker'" :key="field.name" class="metadata-entry">
            <label :for="field.name">{{ field.title }}</label>
            <b-datepicker
              :id="field.name"
              v-model="interactionToCreate[field.name]"
              rounded
              position="is-top-left"
              size="is-small"
              locale="es-ES" />
          </div>
          <div v-if="field.type === 'text'" :key="field.name" class="metadata-entry">
            <b-field :label="field.title" custom-class="has-text-weight-normal">
              <input
                :id="field.name"
                v-model="interactionToCreate[field.name]"
                class="input is-small input-address"
                placeholder="Dirección">
            </b-field>
          </div>
          <div v-if="field.type === 'timePicker'" :key="field.name" class="metadata-entry">
            <label :for="field.name">{{ field.title }}</label>
            <b-timepicker
              :id="field.name"
              v-model="interactionToCreate[field.name]"
              rounded
              size="is-small"
              locale="es-ES"
              placeholder="Seleccione una hora" />
          </div>
        </template>
      </div>
    </div>
    <p v-if="errorMessage" class="help is-danger"> {{ errorMessage }} </p>
    <b-field class="is-grouped is-grouped-right">
      <b-button
        id="create-new-interaction"
        :disabled="buttonIsDisabled"
        class="is-button-primary"
        rounded
        @click="createNewInteraction()">
        Registrar
      </b-button>
    </b-field>
  </div>
</template>
<script>
import { dateToFormatedString } from '@/infrastructure/date';

export default {
  name: 'AddInteractionForm',
  props: {
    clientId: { default: '' },
    fields: { default: () => [] }
  },
  data() {
    const min = new Date();
    min.setHours(9);
    min.setMinutes(0);
    const max = new Date();
    max.setHours(18);
    max.setMinutes(0);
    return {
      interactionToCreate: {},
      buttonIsDisabled: false,
      errorMessage: '',
      minTime: min,
      maxTime: max
    };
  },
  watch: {
    fields: {
      handler(newFields) {
        const fieldsToUpdate = newFields.filter(({ updatable }) => updatable === true);
        fieldsToUpdate.forEach(({ name, defaultValue }) => {
          this.interactionToCreate[name] = defaultValue;
        });
      },
      deep: true
    }
  },
  mounted() {
    this.resetForm();
    // Una vez creada la nueva interacción, libera el botón y resetea
    if (this.$parent && this.$parent.$parent) {
      this.$parent.$parent.$on('new-interaction-successfully-created', () => {
        this.buttonIsDisabled = false;
        this.resetForm();
      });
    }
  },
  methods: {
    createNewInteraction() {
      // bloquea el botón
      this.buttonIsDisabled = true;

      // revisa que haya comentario
      if (!this.interactionToCreate.comment) {
        this.errorMessage = this.$t('must-type-comment');
        this.buttonIsDisabled = false;
        return;
      }

      // formatea campos de fecha
      const dateFields = this.fields.filter(({ type }) => type === 'datepicker');
      const newInteraction = { ...this.interactionToCreate };

      dateFields.forEach(({ name }) => {
        if (newInteraction[name]) {
          newInteraction[name] = newInteraction[name].toISOString().substring(0, 10);
        }
      });

      // formatea campos de tipo timePicker
      const timePickerFields = this.fields.filter(({ type }) => type === 'timePicker');
      timePickerFields.forEach(({ name }) => {
        if (newInteraction[name]) {
          newInteraction[name] = dateToFormatedString(newInteraction[name], 'HH:mm');
        }
      });
      // emite el objeto con la nueva interacción
      this.$emit('create-new-interaction', newInteraction);
    },
    resetForm() {
      this.interactionToCreate = this.fields.reduce((accumIn, { name, defaultValue }) => {
        const accum = { ...accumIn };
        accum[name] = defaultValue;
        return accum;
      }, {});
    }
  }
};
</script>
<style scoped>
.interactions-creator {
  border-radius: 1.5rem;
  padding: 1% 4%;
}
.card-item {
  overflow: visible !important;
  z-index: 1;
}
.med-size-text {
  font-size: 1.1rem;
}
.metadata {
  width: 100%;
  margin-top: 2%;
  display: grid;
  grid-template-columns: repeat( auto-fit, minmax(14rem, 1fr));
  place-items: center start;
  gap: 1.5rem;
}
.metadata .metadata-entry {
  display: flex;
  flex-flow: column wrap;
  justify-items: start;
  align-items: flex-start;
  gap: 0.5rem;
}
.button {
  margin-top: 1%;
}
.input-address{
  border-radius: 10rem;
}
@media (max-width: 900px) {
  .med-size-text {
    font-size: 0.9rem;
  }
}
@media (max-width: 350px) {
  .med-size-text {
    font-size: 0.75rem;
  }
}
</style>
